import { render } from "./FormPanel.vue?vue&type=template&id=4aa7a4b8&ts=true"
import script from "./FormPanel.vue?vue&type=script&lang=ts"
export * from "./FormPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__